import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02335c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "summary" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "steps"
}
const _hoisted_5 = { class: "split" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "summary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-panel", { pc: $setup.os.isPc || $setup.os.isHorizontal.value, 'calc-result': $setup.result }])
  }, [
    _createElementVNode("h2", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('scene.navPath')), 1 /* TEXT */),
      (!$setup.os.isPc || $setup.os.isTablet)
        ? (_openBlock(), _createBlock(_component_ui_icon, {
            key: 0,
            type: "close",
            onClick: $setup.useEmitLeave
          }, null, 8 /* PROPS */, ["onClick"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ui_icon, {
        type: "change",
        class: _normalizeClass([{ disabled: !$setup.store.navigation[0] && !$setup.store.navigation[1] }, "transform"]),
        onClick: $setup.transform,
        ctrl: ""
      }, null, 8 /* PROPS */, ["class"]),
      _createVNode($setup["Input"], {
        placeholder: _ctx.$t('scene.navPlaceholder') + _ctx.$t('scene.navStart'),
        valueLabel: $setup.store.navigation[0]?.label ?? _ctx.$t('scene.navStart'),
        icon: "iorigin",
        value: $setup.store.navigation[0],
        onChangeValue: _cache[0] || (_cache[0] = val => $setup.changeNavigation(val, 0)),
        onClear: _cache[1] || (_cache[1] = ($event: any) => ($setup.clear(0)))
      }, null, 8 /* PROPS */, ["placeholder", "valueLabel", "value"]),
      _createVNode($setup["Input"], {
        placeholder: _ctx.$t('scene.navPlaceholder') + _ctx.$t('scene.navEnd'),
        valueLabel: $setup.store.navigation[1]?.label ?? _ctx.$t('scene.navEnd'),
        icon: "destination",
        value: $setup.store.navigation[1],
        onChangeValue: _cache[2] || (_cache[2] = val => $setup.changeNavigation(val, 1)),
        onClear: _cache[3] || (_cache[3] = ($event: any) => ($setup.clear(1)))
      }, null, 8 /* PROPS */, ["placeholder", "valueLabel", "value"])
    ]),
    ($setup.result)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            ($setup.time)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('sys.time.about') + $setup.time), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("p", null, _toDisplayString($setup.round($setup.result.dis, 2)) + " m", 1 /* TEXT */)
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ui_icon, {
                    type: "origin",
                    class: "start"
                  }),
                  _createVNode(_component_ui_icon, {
                    type: "destination",
                    class: "end"
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.result.steps, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", 
            i === 0 ? 'start' : i === $setup.result.steps.length - 1 ? 'end' : ''
          ])
                  }, [
                    _createElementVNode("p", null, _toDisplayString(item.desc), 1 /* TEXT */),
                    (item.dis)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.dis) + "m", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : ($setup.err)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString($setup.err), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}